import { BarChart, BarChartProps } from '@mantine/charts';

export function StackedBarChart(props: BarChartProps) {
  return (
    <BarChart gridAxis="none" h={250} type="stacked" w={'100%'} {...props} />
  );
}

export default StackedBarChart;
